export default "__VITE_ASSET__VZ2WKn_a__"